import React from "react";
import "../../Assets/Styles/pages/footer.scss";
import { useTranslation } from "react-i18next";
import LottiePlayer from "../../Components/LottiePlayer/lottiePlayer";
import error404 from "../../Assets/Animations/error404.json";
import { Col, Row } from "react-bootstrap";

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Row className="d-flex justify-content-center align-items-center">
      <Row className="d-flex justify-content-center align-items-center">
        <Col className="d-flex justify-content-center align-items-center mt-5 pt-5">
          <span className="productSansBold text_64">{t("Oops")}</span>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center align-items-center">
        <Col className="d-flex justify-content-center align-items-center mb-5 pt-2">
          <span className="productSans text_24 text-center">
            {t("NotFound")}
          </span>
        </Col>
      </Row>

      <Col xs={8} lg={4} className="mb-5">
        <LottiePlayer src={error404} />
      </Col>
    </Row>
  );
};
export default NotFound;
